import React from "react";
import { Tooltip } from "@mui/material";
import styles from "./index.module.scss";
import search from "../../../assets/images/search.svg";
import clearIcon from "../../../assets/images/close-icon.svg";
import opendropdown from "../../../assets/images/opendropdown.svg";
import closedropdown from "../../../assets/images/closedropdown.svg";
import filter from "../../../assets/images/filter.svg";
import appliedFilter from "../../../assets/images/filterApplied.svg";
import { forwardRef } from "react";
import { SidebarItemState, ToolBarProps } from "../../../types/seatApproval";



const PreferenceDropDown = forwardRef<HTMLDivElement, ToolBarProps>(
  (
    {
      selectedOption,
      isDropdownOpen,
      searchText,
      searchValue,
      sessions,
      setIsDropdownUserList,
      setSelectedOption,
      setDropdownAllocatedSessionId,
      setIsDropdownOpen,
      loadUsers,
      setSelectedSidebarItem,
      handleDropdownSessionSelect,
      setSearchText,
      setFinalSearchText,
      handleSearch,
      setSearchValue,
      setPaginationProps,
      isOpenFilter,
      setIsOpenFilter,
      isFilterApplied = false,
      setAppliedFilters,
      setFilterItem,
    },
    ref,
  ) => {
    return (
      <div
        className={styles.toolbarContainer}
        ref={ref}
        onClick={() => {
          if (isDropdownOpen) setIsDropdownOpen(false);
        }}
      >
        <div className={styles.statusSelector}>
          <span
            className={styles.toolbar}
            onClick={() => setIsDropdownOpen((prev: boolean) => !prev)}
          >
            {selectedOption?.label || "Select"}{" "}
          </span>
          <span
            className={styles.dropdownArrow}
            onClick={() => setIsDropdownOpen((prev: boolean) => !prev)}
          >
            <img
              src={isDropdownOpen ? opendropdown : closedropdown}
              alt="dropdown"
            />
          </span>
          {isDropdownOpen && (
            <div className={styles.dropdownMenu}>
              <div
                className={styles.dropdownItem}
                onClick={() => {
                  setPaginationProps((prev) => ({
                    ...prev,
                    currentPage: 1,
                  }));
                  setIsDropdownUserList(false);
                  setSelectedOption({
                    label: "All",
                    value: "all",
                    data: "",
                  });
                  setDropdownAllocatedSessionId(null);
                  setIsDropdownOpen(false);
                  setAppliedFilters({});
                  setSelectedSidebarItem({
                    key: "total",
                    kpiCategory: "all",
                    kpiFilter: "all",
                  });
                  loadUsers(
                    0,
                    true,
                    {},
                    {
                      kpiFilter: "all",
                      approvalStatus: "all",
                    },
                  );
                  setFilterItem({
                    kpiFilter: "all",
                    approvalStatus: "all",
                  })
                }}
              >
                All
              </div>
              <div
                className={styles.dropdownItem}
                onClick={() => {
                  setIsDropdownUserList(false);
                  setSelectedOption({
                    label: "Unassigned",
                    value: "registered",
                    data: "",
                  });
                  setPaginationProps((prev) => ({
                    ...prev,
                    currentPage: 1,
                  }));
                  setAppliedFilters({});
                  setSelectedSidebarItem({
                    key: "total_unallocated",
                    kpiCategory: "unallocated",
                    kpiFilter: "total_unallocated",
                  });
                  setDropdownAllocatedSessionId(null);
                  setIsDropdownOpen(false);
                  loadUsers(0, true, {}, "total_unallocated");
                  setFilterItem(
                    "total_unallocated"
                  );
                }}
              >
                Unassigned
              </div>
              {sessions.map((session) => (
                <div
                  key={session.id}
                  className={styles.dropdownItem}
                  onClick={() => {
                    if (session.name === "Hold" || session.name === "YTD") {
                      setSelectedSidebarItem({
                        key: `${session.type}_total`,
                        kpiCategory: session.kpiCategory,
                        kpiFilter: session.kpiFilter,
                      });
                      setDropdownAllocatedSessionId(null);
                    } else {
                      setDropdownAllocatedSessionId(session.id);
                      setSelectedSidebarItem({
                        key: `${session.kpiFilter}_total`,
                        kpiCategory: session.kpiCategory,
                        kpiFilter: session.kpiFilter,
                      });
                      // handleDropdownSessionSelect(session);
                    }
                    loadUsers(
                      0,
                      true,
                      {},
                      {
                        kpiFilter: session.kpiFilter,
                        approvalStatus: session.kpiCategory,
                      },
                    );
                    setFilterItem({
                      kpiFilter: session.kpiFilter,
                      approvalStatus: session.kpiCategory,
                    });
                    setPaginationProps((prev) => ({
                      ...prev,
                      currentPage: 1,
                    }));
                    setIsDropdownUserList(false);
                    setAppliedFilters({});
                    setSelectedOption({
                      label: session.name,
                      value: session.type,
                      data: session,
                    });
                  
                    setIsDropdownOpen(false);
                  }}
                >
                  {session.name !== "Hold" && session.name !== "YTD"
                    ? `${session.name} blessed`
                    : session.name}
                </div>
              ))}
              <div className={styles.dropdownDivider} />
              <div
                className={styles.dropdownItem}
                onClick={() => {
                  setSelectedSidebarItem({
                    key: "swap_total",
                    kpiCategory: "registered",
                    kpiFilter: "total_unallocated",
                  });
                  setPaginationProps((prev) => ({
                    ...prev,
                    currentPage: 1,
                  }));
                  setDropdownAllocatedSessionId(null);
                  setIsDropdownOpen(false);
                  setIsDropdownUserList(false);
                  setSelectedOption({
                    label: "Swap",
                    value: "swap requests",
                    data: "",
                  });
                  loadUsers(
                    0,
                    true,
                    {},
                    {
                      kpiFilter: "swap-requests",
                      approvalStatus: "all",
                      swapRequests: "wants_swap",
                    },
                  );
                  setFilterItem({
                    kpiFilter: "swap-requests",
                    approvalStatus: "all",
                    swapRequests: "wants_swap",
                  });
                }}
              >
                Swap requests
              </div>
            </div>
          )}
        </div>
        <div className={styles.searchContainer}>
          {searchValue.open && (
            <div className={styles.search} data-testid="search-container">
              <input
                type="text"
                className={styles.searchInput}
                autoFocus
                value={searchText}
                placeholder="Search seeker with name"
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch(e.currentTarget.value);
                  }
                }}
                data-testid="search-input"
              />
              {searchText && (
                <button
                  className={styles.clearIcon}
                  onClick={() => {
                    setSearchText("");
                    setFinalSearchText("");
                  }}
                  data-testid="clear-button"
                >
                  <img src={clearIcon} alt="clear" data-testid="clear-icon" />
                </button>
              )}
            </div>
          )}
          <Tooltip title="Search" arrow>
            <button className={styles.searchIcon} data-testid="search-button">
              <img
                src={search}
                alt="search"
                data-testid="search-icon"
                onClick={() =>
                  setSearchValue({ value: "", open: !searchValue.open })
                }
              />
            </button>
          </Tooltip>
          <Tooltip title="Filter" arrow>
            <img
              src={isFilterApplied ? appliedFilter : filter}
              alt="toggle dropdown"
              className={styles.filterIcon}
              onClick={() => {
                setIsOpenFilter(!isOpenFilter);
              }}
            />
          </Tooltip>
        </div>
      </div>
    );
  },
);

PreferenceDropDown.displayName = "PreferenceDropDown";
export { PreferenceDropDown };
